module.exports = __webpack_public_path__ + "img/invoices.cba35754.svg";